import { chunk } from 'lodash';

export type AttributeLayout = {
  number: 2 | 3 | 4;
  threshold?: number;
};

export type AttributeFormLayout = 'horizontal' | 'vertical';

export const resolveAttributeLayout = <T>(attributes: T[], layout?: AttributeLayout) => {
  const { number = 1, threshold = 0 } = layout ?? {};
  const columnCount = attributes.length > threshold ? number : 1;
  const columns = chunk(attributes, Math.max(1, Math.ceil(attributes.length / columnCount)));

  return {
    columnCount,
    columns,
  };
};
